import { toSearchableString } from 'app/utils';

const TEMPLATE_NAME = 'COMPLETED_VISITS_PROFESSIONAL';

const sort = function (a, b) {
    if (a.end && b.end) {
        return new Date(b.end) - new Date(a.end);
    } else if (a.end && b.dateDone) {
        return new Date(b.dateDone) - new Date(a.end);
    } else if (a.dateDone && b.end) {
        return new Date(b.end) - new Date(a.dateDone);
    } else if (a.dateDone && b.dateDone) {
        return new Date(b.dateDone) - new Date(a.dateDone);
    }
};

const filterByTerm = (item, term) => toSearchableString(item).includes(toSearchableString(term));

const filterData = (data, term) => {
    const result = data.filter(item => {
        const patientName = item.patient.name ? filterByTerm(item.patient.name, term) : false;
        const professionalName = item.professional.name ? filterByTerm(item.professional.name, term) : false;
        const code = item.code ? filterByTerm(item.code, term) : false;
        return professionalName || patientName || code;
    });
    if (sort) {
        result.sort(sort);
    }
    return result;
};

const initialState = () => ({
    loading: false,
    data: [],
    professional: false,
    // nurse: false,
    activeIndex: 0,
    filter: {
        term: '',
        data: [],
    },
});

const reducer = (state = initialState(), action) => {
    switch (action.type) {
        case `${TEMPLATE_NAME}_PENDING`: {
            return {
                ...state,
                loading: true,
            };
        }
        case `${TEMPLATE_NAME}_REJECTED`: {
            return {
                ...state,
                loading: false,
            };
        }
        case `${TEMPLATE_NAME}_FULFILLED`: {
            const data = action.payload;
            return {
                ...state,
                loading: false,
                professional: true,
                // nurse: false,
                data: data,
                filter: {
                    ...state.filter,
                    data: filterData(data, state.filter.term),
                },
            };
        }
        case `${TEMPLATE_NAME}_SEARCH`: {
            const term = action.payload;
            return {
                ...state,
                filter: {
                    ...state.filter,
                    term,
                    data: filterData(state.data, term),
                },
            };
        }
        case `${TEMPLATE_NAME}_UPDATE`: {
            const updatedRow = action.payload;
            const data = state.data.map(row => (row.idCliente === updatedRow.idCliente ? updatedRow : row));
            return {
                ...state,
                data,
                filter: {
                    ...state.filter,
                    data: filterData(data, state.filter.term),
                },
            };
        }
        case `${TEMPLATE_NAME}_DELETE`: {
            const deletedId = action.payload;
            const data = state.data.filter(data => data.idCliente !== deletedId);
            
            return {
                ...state,
                loading: false,
                data,
                filter: {
                    ...state.filter,
                    data: filterData(data, state.filter.term, state.filter.type),
                },
            };
        }
        case `${TEMPLATE_NAME}_CREATE`: {
            const newRow = action.payload;
            const data = [...state.data, newRow];
            return {
                ...state,
                loading: false,
                data,
                filter: {
                    ...state.filter,
                    data: filterData(data, state.filter.term, state.filter.type),
                },
            };
        }
        case `${TEMPLATE_NAME}_CHANGE_TAB`: {
            const activeIndex = action.payload;
            return {
                ...state,
                activeIndex
            };
        }
        case `${TEMPLATE_NAME}_RESET`: {
            return initialState();
        }
        default:
            return state;
    }
};
export default reducer;